export const SYSTEM = {
  VERSION: import.meta.env.VITE_VERSION as string,
  REALM: import.meta.env.VITE_REALM as string,
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
};
